module.exports = __webpack_public_path__ + "img/header@2x.807c5004.png";